'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'

const CONSENT_KEY = 'cookie_consent'

export function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY)
    if (!consent) setVisible(true)
  }, [])

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setVisible(false)
    // Notify other components that consent was granted
    window.dispatchEvent(new CustomEvent('cookieConsentAccepted'))
  }

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined')
    setVisible(false)
    window.dispatchEvent(new CustomEvent('cookieConsentDeclined'))
  }

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-[#FFC933]/30 bg-[#2B0A4A] shadow-2xl"
    >
      <div className="mx-auto max-w-7xl px-4 py-3 md:px-6 md:py-5 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold text-white md:text-sm md:mb-1">We value your privacy</p>
          <p className="text-xs text-white/80 leading-snug md:text-sm md:leading-relaxed">
            We use cookies to enhance your experience and analyze site usage.{' '}
            <span className="hidden md:inline">
              Essential cookies are always enabled to ensure the platform works properly.{' '}
            </span>
            <Link
              href="/privacy-policy"
              className="underline text-[#FFC933] hover:text-[#FFC933]/80 transition-colors"
            >
              Privacy Policy
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 gap-2 md:gap-3">
          <button
            onClick={handleDecline}
            className="rounded-lg border border-white/30 px-4 py-1.5 text-xs text-white/80 hover:border-white/60 hover:text-white transition-colors md:px-5 md:py-2 md:text-sm"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="rounded-lg bg-[#FFC933] px-4 py-1.5 text-xs font-semibold text-[#2B0A4A] hover:bg-[#FFC933]/90 transition-colors md:px-5 md:py-2 md:text-sm"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  )
}
